<script lang="ts">
import { defineComponent, h } from "vue";

// Renders its tag around the slot only when `when` is true, otherwise the slot alone (no empty wrapper in the old UI).
export default defineComponent({
  name: "UiWrapIf",

  inheritAttrs: false,

  props: {
    when: {
      type: Boolean,
      required: true,
    },

    tag: {
      type: String,
      default: "div",
    },
  },

  setup(props, { attrs, slots }) {
    return () => {
      const nodes = slots.default?.() ?? [];

      return props.when ? h(props.tag, attrs, nodes) : nodes;
    };
  },
});
</script>
